import {
	GET_SNAPSHOTS,
	GET_SNAPSHOTS_SUCCESS,
	GET_SNAPSHOTS_FAILURE,
	DELETE_SNAPSHOT_SUCCESS,
	DELETE_SNAPSHOT,
	ADD_TO_SNAPSHOTS,
	LOAD_MORE_SNAPSHOTS,
	LOAD_MORE_SNAPSHOTS_SUCCESS,
} from './types';

export const getSnapshotsAction = () => ({
	type: GET_SNAPSHOTS,
});

export const getSnapshotsSuccessAction = (payload: any) => ({
	type: GET_SNAPSHOTS_SUCCESS,
	payload,
});

export const getSnapshotsFailureAction = (error: Error) => ({
	type: GET_SNAPSHOTS_FAILURE,
	payload: error,
});

export const removeFromSnapshotsAction = (payload: any) => ({
	type: DELETE_SNAPSHOT,
	payload,
});

export const removeFromSnapshotsSuccessAction = (payload: any) => ({
	type: DELETE_SNAPSHOT_SUCCESS,
	payload,
});

export const addToSnapshotsAction = (payload: any) => ({
	type: ADD_TO_SNAPSHOTS,
	payload,
});

export const loadMoreSnapshotsAction = (payload: any) => ({
	type: LOAD_MORE_SNAPSHOTS,
	payload,
});

export const loadMoreSnapshotsSuccessAction = (payload: any) => ({
	type: LOAD_MORE_SNAPSHOTS_SUCCESS,
	payload,
});
